import { createIcon } from '../createIcon';

export const ShuttleVanIconConfig = {
  name: 'ShuttleVanIcon',
  height: 512,
  width: 640,
  svgPath: 'M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const ShuttleVanIcon = createIcon(ShuttleVanIconConfig);

export default ShuttleVanIcon;